const STORAGE_KEY = 'ghl_active_instance';

export function getActiveInstance() {
  const value = localStorage.getItem(STORAGE_KEY);
  return value ? String(value) : '';
}

export function setActiveInstance(instanceKey) {
  if (!instanceKey) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, String(instanceKey));
}

export function clearActiveInstance() {
  localStorage.removeItem(STORAGE_KEY);
}
